/**
 * @Author xyguo
 * @description 认证新增编辑页面
 * @Date 2020/12/23
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool, utils_tool} from '@/tool'
import {Form, message, Popconfirm, Spin, Upload} from "antd";
import {WizTableForm} from '@/containers/common'

const organizationConfig = WizTableForm.Config.organizationBrandNode(this, {
  apiParams: {
    state: 1,
    organizationNodeCategory: ["2"]
  }
})

let {WizContainer, modelUtils} = framework_tool;
let {WizCard, WizSelect, WizSwitch, WizForm, WizSpin, WizModal, WizButton, WizIcon, WizDropdown, WizMenu, WizTable, WizRadio, WizDatePicker, WizTooltip} = component_tool;
let Item = Form.Item;
let Option = WizSelect.Option;
let {Session} = utils_tool;

class RemoteAuthDetail extends WizContainer {

  componentName = 'RemoteAuthDetail';

  constructor(props) {
    super(props);
    const {history} = props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/remoteAuth/remoteAuthList/remoteAuthDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        Session.set('remoteAuthDetailRecord', initialValue)
      } else {
        initialValue = Session.get('remoteAuthDetailRecord') || {};
      }
    }
    this.state = {
      showPosition: initialValue && initialValue.type === 1 ? 'select' : "hidden",
      orgDisable: initialValue && initialValue.type === 2 ? true : false,
      orgIdList: initialValue && initialValue.orgIdList ? initialValue.orgIdList : [],
      orgNameMapList: initialValue.orgNameMapList ? initialValue.orgNameMapList : [],
      type: initialValue.type,
      name:initialValue.name,
      passScore:initialValue.passScore,
      keyItemKey: new Date().getTime(),
    };
    this.initialValue = initialValue;

  }

  _componentDidMount() {
    this.getPositionInfo();
    if (this.initialValue && this.initialValue.programId) {
      // this.getOrgInfo();
    }
  }

  /**
   * 获取远程评估岗位配置信息
   * @private
   */
  getPositionInfo() {
    this.doAction({
      path: 'remoteAuth/getRemoteAuthPositionConfig',
      payload: {
        key: 'remoteAuth@getRemoteAuthPositionConfig',
      }
    });
  };

  propsAndStateOnChange = {
    addRemoteAuth: this._addRemoteAuthOver.bind(this),
    updateRemoteAuth: this._updateRemoteAuthOver.bind(this),
    getPositionInfo: this._getPositionInfoOver.bind(this),
  };


  /**
   * 认证新增成功返回原页面，失败弹出提示
   */
  _addRemoteAuthOver(nextProps, nextState) {
    if (nextProps.addRemoteAuth.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/remoteAuth/remoteAuthList');
    } else {
      wizNotice.error('提交失败：' + nextProps.addRemoteAuth.msg);
    }
    return true;
  }

  /**
   * 认证修改成功返回原页面，失败弹出提示
   */
  _updateRemoteAuthOver(nextProps, nextState) {
    if (nextProps.updateRemoteAuth.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/remoteAuth/remoteAuthList');
    } else {
      wizNotice.error('提交失败：' + nextProps.updateRemoteAuth.msg);
    }
    return true;
  }

  /**
   * 将查询到的品牌选项加载到记录中
   */
  _getPositionInfoOver(nextProps, nextState) {
    let positionInfo = nextProps.getPositionInfo.data;
    let positionInfoNew = [];
    let positionIdsNew = [];
    if (nextProps.getPositionInfo.code == 1 && positionInfo.length && positionInfo.length > 0) {
      positionInfo.forEach(element => {
        positionInfoNew.push({code: element.id, codeName: element.name})
        positionIdsNew.push(element.id);
      });
    }
    this.initialValue.positionInfoNew = positionInfoNew;
    this.initialValue.positionIdsNew = positionIdsNew;
    return true;
  }


  // /**
  //  * 过滤字段值为undefined&null的字段
  //  * @param fieldsValue
  //  */
  // fitterFieldsValue(fieldsValue) {
  //   let fitterValues = fieldsValue;
  //   Object.keys(fieldsValue).forEach(key => {
  //     const value = fieldsValue[key];
  //   });
  //   if(fitterValues.type===1 && fitterValues.trainSiteId){
  //     fitterValues.trainSiteId = null;
  //   }
  //   return fitterValues;
  // };

  /**
   * 保存/更新 远程认证
   * @param values
   * @private
   */
  _saveRemoteAuth(values) {
    const {history} = this.props;
    let apiPath = "remoteAuth/add";
    let payloadKey = "addRemoteAuth";
    if (history.location && history.location.pathname === '/remoteAuth/remoteAuthList/remoteAuthDetailUpd') {
      apiPath = "remoteAuth/update";
      payloadKey = "updateRemoteAuth";
    }
    // let fitterValues = this.fitterFieldsValue(values);
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          ...values
        }
      }
    });
  };


  _render() {
    const {remoteAuthLoading} = this.props;

    let initialValue = this.initialValue;
    let cardTitle = '新增';
    const {id} = initialValue;
    if (id) {
      cardTitle = '编辑';
    }

    let columns = [
      {
        formItem: {
          type: "hidden",
          initialValue: initialValue.id
        },
        name: "id"
      },
      {
        title: "检核类型",
        name: "type",
        dict: [
          {code: 0, codeName: '远程认证'},
          {code: 1, codeName: '远程评估'},
          {code: 2, codeName: 'NEV认证'},
        ],
        formItem: {
          type: "select",
          initialValue: this.state.type,
          disabled: !(initialValue.type === undefined),
          rules: [{
            required: true,
            message: '请输入检核类型',
          },
          ],
          onChange: (form, value, e) => {
            if (value != null && value != undefined && value !== 2) {
              form.setFieldsValue({orgIds: []});
              this.setState({
                type:value,
                showPosition: value != null && value != undefined && value === 1 ? 'select' : 'hidden',
                orgDisable: value != null && value != undefined && value === 2 ? true : false,
                orgIdList: [],
                orgNameMapList: [],
                keyItemKey: new Date().getTime(),
              })
            } else if (value != null && value != undefined && value === 2) {
              form.setFieldsValue({orgIds: [{id: 1161, name: '凯迪拉克'}]});
              this.setState({
                type:value,
                showPosition: value != null && value != undefined && value === 1 ? 'select' : 'hidden',
                orgDisable: value != null && value != undefined && value === 2 ? true : false,
                orgIdList: [1161],
                orgNameMapList: [{name: "凯迪拉克", id: 1161}],
                keyItemKey: new Date().getTime(),
              })
            }

          }
        }
      },
      {
        title: "检核项目",
        name: "name",
        formItem: {
          initialValue: this.state.name,
          maxLength: 25,
          rules: [{
            required: true,
            message: '请输入认证名称',
          }
            // ,{
            //   pattern: /^[A-Za-z\d_\-\u4e00-\u9fa5《》()]{1,15}$/,
            //   message: '班级名称不允许使用特殊符号'
            // }
          ],
          onChange: (form, value, e) => {
            this.setState({
              name:value,
            })
          },
          placeholder: "请输入认证名称,长度不能超过25个字符"
        }
      },
      this.state.showPosition === 'select' ? {
        title: "固定岗位受众",
        name: "positionIdList",
        dict: initialValue.positionInfoNew,
        formItem: {
          type: this.state.showPosition, //"select",
          mode: 'multiple',
          initialValue: initialValue.positionIdList ? initialValue.positionIdList : initialValue.positionIdsNew,
          initRows: initialValue.positionList ? initialValue.positionList : initialValue.positionInfoNew,
          rules: [{
            required: true,
            message: '请输入固定岗位受众',
          }
          ],
        }
      } : {},
      {
        title: "品牌",
        name: "orgIds",
        formItem: {
          diy: WizTableForm,
          ...organizationConfig,
          rowTitle: 'name',
          disabled: this.state.orgDisable,
          initialValue: this.state.orgIdList,
          initRows: this.state.orgNameMapList,
          rules: [{
            required: true,
            message: '请选择品牌',
          }]
        },
      },
      {
        title: "通过分数",
        name: "passScore",
        formItem: {
          type: 'number',
          initialValue: this.state.passScore,
          min: 0,
          max: 9999.9,
          rules: [{
            required: true,
            message: '请输入限制人数',
          }],
          onChange: (form, value, e) => {
            this.setState({
              passScore:value,
            })
          },
        }
      },

    ];

    let onSubmit = this._saveRemoteAuth.bind(this);

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
      // style: {maxWidth: 800}
    };

    return (
      <WizCard>
        <Spin tip={'加载中'} spinning={remoteAuthLoading}>
          <WizForm key={ this.state.keyItemKey } className={'form-inline'} {...formProps} />
        </Spin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {remoteAuth} = state;
  const addRemoteAuth = modelUtils.getModelEntity(remoteAuth, "addRemoteAuth");
  const updateRemoteAuth = modelUtils.getModelEntity(remoteAuth, "updateRemoteAuth");
  const getPositionInfo = modelUtils.getModelEntity(remoteAuth, "remoteAuth@getRemoteAuthPositionConfig");
  const load = modelUtils.getLoadingState(state, ['remoteAuth']);
  return {
    addRemoteAuth,
    updateRemoteAuth,
    getPositionInfo,
    ...load
  }
};

export default connect(mapStateToProps)(RemoteAuthDetail);
